// extracted by mini-css-extract-plugin
module.exports = {"truncated":"BreadCrumbs_truncated__Pl3gZ","root":"BreadCrumbs_root__YhX6t","link":"BreadCrumbs_link__QZ9R0","text":"BreadCrumbs_text__gqlHJ"};